// A tab opened before a deploy still runs the old build, and its screens are
// lazy chunks with hashed names. The server keeps the previous build's assets
// for exactly this, but a tab two deploys behind would ask for files nobody has
// and the next navigation would fail. Vite announces that failure with a
// `vite:preloadError` event; reloading fetches the new index.html and its
// chunks. At most once a minute, so a real outage cannot loop the page.
const KEY = 'scotus_chunk_reload_at';
const MIN_GAP_MS = 60_000;

export function shouldReloadForChunk(now: number, lastAt: number | null): boolean {
  return lastAt === null || now - lastAt > MIN_GAP_MS;
}

export function installChunkReload(win: Window = window): void {
  win.addEventListener('vite:preloadError', (event) => {
    // Offline, a reload cannot fetch anything better than what failed.
    if (win.navigator && win.navigator.onLine === false) return;
    let last: number | null = null;
    try {
      const raw = win.sessionStorage.getItem(KEY);
      last = raw ? Number(raw) : null;
      const now = Date.now();
      if (!shouldReloadForChunk(now, last)) return;
      win.sessionStorage.setItem(KEY, String(now));
    } catch {
      // Storage blocked: nothing would survive the reload to stop the next one, so do not start a loop.
      return;
    }
    event.preventDefault();
    win.location.reload();
  });
}
